// extracted by mini-css-extract-plugin
export default {"searchControl":"searchControl---ikwV9","marginBottom0":"marginBottom0---Xa_6a","marginTop0":"marginTop0---DsznE"};